import {FieldViewProps} from "../../../../render/view";
import React from "react";

export default function FieldTimeReportIsBillable_ViewProperty(props: FieldViewProps) {

    const classes = Classes('ui5-prop', props.className, {
        green    : props.model.isBillable,
        gray   : !props.model.isBillable,
    })

    const label : string = props.model.isBillable ? 'Billable' : 'Non Billable'

    return (
        <div className={classes}>
            {label}
        </div>
    )

}